<template>
  <section class="community-section">
    <div class="container">
      <div class="row align-items-center">
        <!-- Section texte et CTA -->
        <div class="col-lg-6">
          <div class="content-section">
            <!-- Membres et avatars -->
            <div class="members-info">
              <div class="avatars-group">
                <div class="avatar" v-for="i in 5" :key="i" @mouseenter="animateAvatar(i)" @mouseleave="stopAvatarAnimation(i)">
                  <div class="avatar-placeholder" :class="{ 'avatar-hover': hoveredAvatar === i }" :style="{ backgroundColor: getAvatarColor(i) }">
                    {{ getAvatarInitial(i) }}
                  </div>
                </div>
              </div>
              <span class="members-count">{{ membersCount }} membres</span>
            </div>

            <!-- Titre principal -->
            <h2 class="main-title" data-aos="fade-up" data-aos-delay="200">
              Développez votre potentiel dans une communauté bienveillante
            </h2>

            <!-- Sous-titre -->
            <p class="subtitle" data-aos="fade-up" data-aos-delay="400">
              Rejoignez PREFERE PLUS et transformez votre carrière avec notre accompagnement personnalisé
            </p>

            <!-- Boutons d'action -->
            <div class="cta-buttons" data-aos="fade-up" data-aos-delay="600">
              <router-link to="/register" class="btn btn-primary join-btn">
                <i class="fas fa-user-plus me-2"></i>
                S'inscrire
              </router-link>
              <router-link to="/jobs-offers" class="btn btn-outline-primary learn-btn">
                <i class="fas fa-briefcase me-2"></i>
                Nos offres d'emploi
              </router-link>
            </div>

            <!-- Statistiques -->
            <div class="stats-section" data-aos="fade-up" data-aos-delay="800">
              <div class="stat-item" v-for="(stat, key) in stats" :key="key">
                <div class="stat-number" :data-target="stat">0</div>
                <div class="stat-label">{{ getStatLabel(key) }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Section image -->
        <div class="col-lg-6">
          <div class="image-section" data-aos="fade-left" data-aos-delay="400">
            <div class="image-container">
              <div class="main-image-placeholder">
                <div class="placeholder-content">
                  <i class="fas fa-users fa-3x text-primary mb-3"></i>
                  <h4>Notre équipe PREFERE PLUS</h4>
                  <p>Une communauté dédiée à votre succès professionnel</p>
                </div>
              </div>
              
              <!-- Éléments décoratifs -->
              <div class="floating-elements">
                <div class="floating-card card-1" @click="showCardInfo('offres')">
                  <i class="fas fa-briefcase"></i>
                  <span>Offres d'emploi</span>
                </div>
                <div class="floating-card card-2" @click="showCardInfo('formation')">
                  <i class="fas fa-graduation-cap"></i>
                  <span>Formation continue</span>
                </div>
                <div class="floating-card card-3" @click="showCardInfo('accompagnement')">
                  <i class="fas fa-handshake"></i>
                  <span>Accompagnement</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal pour les informations des cartes -->
    <div class="modal fade" id="cardInfoModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ cardInfo.title }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <p>{{ cardInfo.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CommunitySection',
  data() {
    return {
      membersCount: 1250,
      stats: {
        candidates: 500,
        success: 95,
        companies: 50
      },
      avatarColors: [
        '#29b3cd',
        '#bc6a3c',
        '#1d9ed9',
        '#ff6b35',
        '#28a745'
      ],
      avatarNames: [
        'Marie',
        'Jean',
        'Sophie',
        'Pierre',
        'Emma'
      ],
      hoveredAvatar: null,
      cardInfo: {
        title: '',
        description: ''
      },
      cardInfoData: {
        offres: {
          title: 'Offres d\'emploi',
          description: 'Découvrez nos offres d\'emploi exclusives et postulez directement en ligne.'
        },
        formation: {
          title: 'Formation continue',
          description: 'Améliorez vos compétences avec nos programmes de formation personnalisés.'
        },
        accompagnement: {
          title: 'Accompagnement personnalisé',
          description: 'Bénéficiez d\'un suivi personnalisé pour maximiser vos chances de succès.'
        }
      }
    }
  },
  mounted() {
    this.animateStats()
  },
  methods: {
    getAvatarColor(index) {
      return this.avatarColors[(index - 1) % this.avatarColors.length]
    },
    getAvatarInitial(index) {
      return this.avatarNames[(index - 1) % this.avatarNames.length].charAt(0)
    },
    animateAvatar(index) {
      this.hoveredAvatar = index
    },
    stopAvatarAnimation() {
      this.hoveredAvatar = null
    },
    getStatLabel(key) {
      const labels = {
        candidates: 'Candidats accompagnés',
        success: 'Taux de réussite',
        companies: 'Entreprises partenaires'
      }
      return labels[key] || key
    },
    animateStats() {
      const statElements = document.querySelectorAll('.stat-number')
      statElements.forEach(element => {
        const target = parseInt(element.getAttribute('data-target'))
        const increment = target / 50
        let current = 0
        
        const timer = setInterval(() => {
          current += increment
          if (current >= target) {
            current = target
            clearInterval(timer)
          }
          element.textContent = Math.floor(current) + (element.getAttribute('data-target') === '95' ? '%' : '+')
        }, 50)
      })
    },
    showCardInfo(type) {
      this.cardInfo = this.cardInfoData[type]
      // Utiliser window.bootstrap au lieu de bootstrap
      const modal = new window.bootstrap.Modal(document.getElementById('cardInfoModal'))
      modal.show()
    }
  }
}
</script>

<style scoped>
.community-section {
  padding: 40px 0 60px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  position: relative;
  overflow: hidden;
}

.community-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="%2329b3cd" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
  pointer-events: none;
}

.content-section {
  padding: 2rem 0;
  position: relative;
  z-index: 2;
}

.members-info {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}

.avatars-group {
  display: flex;
  margin-right: 1rem;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid white;
  margin-left: -10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.3s ease;
}

.avatar:first-child {
  margin-left: 0;
}

.avatar:hover {
  transform: scale(1.1);
  z-index: 10;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
}

.avatar-hover {
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

.members-count {
  color: #6c757d;
  font-size: 0.9rem;
  font-weight: 500;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.subtitle {
  font-size: 1.1rem;
  color: #6c757d;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.join-btn {
  background: linear-gradient(135deg, #29b3cd 0%, #1d9ed9 100%);
  border: none;
  color: white;
  padding: 12px 24px;
  border-radius: 50px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(41, 179, 205, 0.3);
}

.join-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(41, 179, 205, 0.4);
  color: white;
}

.learn-btn {
  border: 2px solid #29b3cd;
  color: #29b3cd;
  background: transparent;
  padding: 12px 24px;
  border-radius: 50px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.learn-btn:hover {
  background: #29b3cd;
  color: white;
  transform: translateY(-2px);
}

.stats-section {
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: #29b3cd;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 500;
}

.image-section {
  position: relative;
  padding: 2rem 0;
}

.image-container {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}

.main-image-placeholder {
  width: 100%;
  height: 400px;
  background: url('https://i.pinimg.com/736x/2e/44/af/2e44aff130658e45a10258310c93ffc7.jpg') no-repeat center center;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.placeholder-content {
  padding: 2rem;
}

.placeholder-content h4 {
  margin-bottom: 1rem;
  font-weight: 600;
}

.placeholder-content p {
  opacity: 0.9;
  font-size: 1.1rem;
}

.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.floating-card {
  position: absolute;
  background: white;
  padding: 12px 16px;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #2c3e50;
  animation: float 3s ease-in-out infinite;
  cursor: pointer;
  pointer-events: auto;
  transition: all 0.3s ease;
}

.floating-card:hover {
  transform: translateY(-5px) scale(1.05);
  box-shadow: 0 12px 30px rgba(0,0,0,0.2);
}

.floating-card i {
  color: #29b3cd;
  font-size: 1.1rem;
}

.card-1 {
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.card-2 {
  top: 50%;
  right: 15%;
  animation-delay: 1s;
}

.card-3 {
  bottom: 20%;
  left: 20%;
  animation-delay: 2s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Responsive */
@media (max-width: 991px) {
  .main-title {
    font-size: 2rem;
  }
  
  .cta-buttons {
    flex-direction: column;
  }
  
  .stats-section {
    justify-content: center;
  }
  
  .floating-card {
    display: none;
  }
}

@media (max-width: 768px) {
  .community-section {
    padding: 60px 0;
  }

  .main-title {
    font-size: 1.8rem;
  }

  .stats-section {
    flex-direction: column;
    gap: 1rem;
  }

  .members-info {
    justify-content: center;
  }

  .main-image-placeholder {
    height: 250px;
  }
}

@media (max-width: 575px) {
  .community-section {
    padding: 40px 0;
  }

  .main-title {
    font-size: 1.4rem;
  }

  .subtitle {
    font-size: 0.95rem;
  }

  .stat-number {
    font-size: 1.5rem;
  }

  .main-image-placeholder {
    height: 200px;
    border-radius: 12px;
  }

  .image-container {
    border-radius: 12px;
  }

  .join-btn, .learn-btn {
    padding: 10px 20px;
    font-size: 0.9rem;
  }
}

/* Animation d'entrée */
.community-section {
  animation: fadeInUp 0.8s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style> 